import React from "react";
import "../../css/appage.css";

export default function AboutUs() {
  return <h1 className="about-us">ABO</h1>;
}
